// Public account admission is separate from private Staging invitations and
// from approval to practise or manage an organisation.
export const PUBLIC_ACCOUNT_ROLES = Object.freeze(['doctor', 'patient']);
export const HIDDEN_CATEGORY_ROLES = Object.freeze(['moh', 'employer']);

export function categoryVisible(role, publicAdmission = false) {
  return !HIDDEN_CATEGORY_ROLES.includes(role)
    && (!publicAdmission || PUBLIC_ACCOUNT_ROLES.includes(role));
}

export async function requestPublicEmailLink(client, email, callbackUrl) {
  const normalized = String(email || '').trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)) throw Error('invalid_email');
  // No category/role metadata, password, invite or caller-supplied identity.
  // New identities remain server-marked as pending until a verified session
  // selects a supported role. Returning identities keep their existing role.
  const { error } = await client.auth.signInWithOtp({
    email: normalized,
    options: { shouldCreateUser: true, emailRedirectTo: callbackUrl },
  });
  if (error) throw Error('email_link_unavailable');
  return { requested: true };
}
